import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import extraService from '../../services/extra';

const initialState = {
  loading: false,
  extraGroups: [],
  error: '',
  meta: {},
};

export const fetchExtraGroups = createAsyncThunk(
  'extra/fetchExtraGroups',
  (params = {}) => {
    return extraService.getAllGroups(params).then((res) => res);
  }
);

const extraGroupSlice = createSlice({
  name: 'extraGroup',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchExtraGroups.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchExtraGroups.fulfilled, (state, action) => {
      const { payload } = action;
      state.loading = false;
      state.extraGroups = Array.isArray(payload?.data) ? payload.data : (payload?.data?.data ?? []);
      state.error = '';
      state.meta = payload?.meta ?? payload?.pagination ?? {};
    });
    builder.addCase(fetchExtraGroups.rejected, (state, action) => {
      state.loading = false;
      state.extraGroups = [];
      state.error = action.error.message;
      state.meta = {};
    });
  },
});

export default extraGroupSlice.reducer;
